<template>
  <v-row>
    <v-col>
      <v-row>
        <v-col
          class="pb-0"
          cols="12"
        >
          <span class="title">
            {{ $t('forms.labels.name') }}
          </span>
          <VTextField
            v-model="data.name"
            :label="$t('forms.labels.representant')"
            outlined
            @input="updateData"
          />
        </v-col>
        <v-col
          class="pt-0"
          cols="12"
        >
          <span class="title">
            {{ $t('forms.labels.comment') }}
          </span>
          <GlobalComment
            :comment="data.comment"
            :canUploadImages="false"
            :showAddSentences="false"
            :showSaveBtn="false"
            @commentChange="updateComment"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import GlobalComment from '@/views/laboratory/workOrder/summary/GlobalComment';


export default {
    components: {
        VTextField,
        GlobalComment,
    },
    props: {
        populateWith: {
            type: Object,
            default: () => ({ }),
        },
    },
    data() {
        return {
            data: {
                name: '',
                comment: {
                    message: '',
                },
            },
        };
    },
    computed: {
        ...mapGetters([
            'labWorkOrder',
            'lang',
            'teamMainLang',
            'siteLang',

        ]),
        labReport() {
            return this.labWorkOrder.summaryReport.reportType.label[this.siteLang || this.teamMainLang];
        },
    },
    watch: {
        populateWith: {
            handler() {
                this.data.name = this.populateWith?.name || '';
                this.data.comment.message = this.populateWith?.message || '';
            },
            immediate: true,
        },
    },
    methods: {
        updateComment(comment) {
            this.data.comment.message = comment;
            this.$emit('sendData', this.data);
        },
        updateData() {
            this.$emit('sendData', this.data);
        },
    },
};
</script>
